import { TextSmall } from '@/components/Texts';
import React from 'react';

const PurposeAndLegalBasisDataProcessing = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (3) Purpose and legal basis of data processing
      </TextSmall>
      <TextSmall>
        We process the personal data described in more detail above in
        accordance with the provisions of the GDPR, the other relevant data
        protection regulations and only to the extent necessary. Insofar as the
        processing of personal data is based on Art. 6 (1) p. 1 lit. f GDPR, the
        aforementioned purposes also represent our legitimate interests.
      </TextSmall>
      <TextSmall>
        The processing of the log data serves statistical purposes and the
        improvement of the quality of our website, in particular the stability
        and security of the connection (legal basis is Art. 6 para. 1 p. 1 lit.
        a or lit. f GDPR).
      </TextSmall>
      <TextSmall>
        Contact form data is processed for the purpose of handling customer
        inquiries (legal basis is Art. 6 para. 1 p. 1 lit. b or lit. f GDPR).
      </TextSmall>
      <TextSmall>
        The processing of data for the performance of our contract is necessary
        to comply with our obligation under the contract and you can comply with
        specific counter-obligations under the contract (e.g. processing payment
        details) in accordance with Article 6 para. 1 lit.b GDPR. If you have
        not yet entered into a contract with us, but you have requested us to
        take a preliminary action, we need to process your personal data to
        fulfil your request. This applies even if you do not ultimately enter
        into a contract with us, as long as the processing was in the context of
        a potential contract with us.
      </TextSmall>
    </>
  );
};

export default PurposeAndLegalBasisDataProcessing;
